import React from 'react';

const avaleht = {
  "avaleht.pealkiri": "Varbla puhkeküla",
  "avaleht.pealkiri2": "Paradiis pärapõrgus",
  "avaleht.tutvustus": () => (
    <>
      <p className="is-4">
        Tere tulemast Varbla Puhkeküla kodulehele, kuid veelgi parem, kui saame
        teile kohapeal öelda:
      </p>
      <h2 className="title is-2">Tere tulemast Varbla Puhkekülla!</h2>

      <p className="is-4">
        <strong>
          Olete jõudnud Pärnumaale mere äärde, kohta mida kutsutakse hellitavalt{" "}
          <span className="is-3">PARADIIS PÄRAPÕRGUS.</span>
        </strong>
      </p>
    </>
  ),
  "avaleht.puhkusEestis": () => (
    <>
      <h2 className="title is-2">Puhkus Eestis!</h2>

      <p>
        Kui otsite kohta, kus veeta puhkus Eestis, siis Liivi lahe rannikul asuv
        Varbla Puhkeküla on selleks ideaalne paik.
      </p>
      <p>Kaunis Eestimaa on seda väärt, et oma puhkus siin veeta!</p>
      <p>
        Mere kaldal asuv Varbla Puhkeküla sobib puhkamiseks nii lastega
        peredele,{" "}
        <a
          href="https://rannatee.ee/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Romantilisel Rannateel
        </a>{" "}
        rändajale, loodusesõbrale kui ka romantika ja privaatsuse otsijatele.
      </p>
      <p>
        Siinne rannik on laidude rohke, mis pakub põnevust mereretkelistele,
        linnuhuvilistele ning jääl seiklejatele.
      </p>
      <p>
        Rannikuloodus sarnaneb kadakaid täis niitude ja karjamaade poolest
        Eestimaa saartele.{" "}
      </p>
      <p>
        Varbla kant jääb eemale suurtest maanteedest ning asulatest, mistõttu
        sobib hästi privaatsuse otsijatele ja loodussõpradele.{" "}
      </p>
      <p>
        Puhkuse Eesti rannikualal muudavad nauditavaks paadiretked merele ja
        läheduses asuvatele väikestele laidudele, õhtused päikeseloojangud,
        suplused ja veevannid merevees, jalutuskäigud mööda rannajoont ning
        kauni looduse avastamine.
      </p>
    </>
  ),
  "avaleht.puit": () => (
    <>
      <h2 className="title is-2">Puit</h2>

      <p>
        AS Varbla Puhkekülas tegeldakse ka puitmaterjali tootmise ja
        töötlemisega.
      </p>
      <p>Müüme erinevaid puitmaterjale:</p>
      <ul>
        <li>ehituslik puitmaterjal</li>
        <li>punnlauad</li>
        <li>liistud</li>
        <li>hööveldatud lauad</li>
        <li>
          puidust aiamööbel, sh:
          <ul>
            <li style={{ fontSize: "1em" }}>lillepotid</li>
            <li style={{ fontSize: "1em" }}>kiiged</li>
            <li style={{ fontSize: "1em" }}>prügikasti ümbrised</li>
            <li style={{ fontSize: "1em" }}>katusega istumispingid</li>
            <li style={{ fontSize: "1em" }}>piknikulauad</li>
          </ul>
        </li>
      </ul>
      <p>
        Kui on millegi vastu huvi, siis infot saab helistades numbritele <br />
        <strong>+372 5061879</strong> (puhkemajandus) <br />
        <strong>+372 53586480</strong> (puitmaterjal)
      </p>
    </>
  ),
  "majutus.kaart.kirjeldus": () => (
    <p>Mitmekülgne hoonetekompleks võimaldab majutada kuni 142 külalist.</p>
  ),
  "toitlustus.kaart.kirjeldus": () => (
    <p>
      Meie poolt pakutav toit muudab meeled rõõmsaks ja enesetunde mõnusaks.
    </p>
  ),
  "yritused.kaart.kirjeldus": () => (
    <p>Erinevad üritused aitavad sisustada Teie vaba aja.</p>
  ),
  "avaleht.puhkuseIdeed": () => (
    <h2 className="title is-2" style={{ marginBottom: "40px" }}>
      Huvitavad võimalused puhkuse veetmiseks Varbla Puhkekülas:
    </h2>
  ),
  "avaleht.koikVajalik": () => (
    <h2 className="title is-2" style={{ marginBottom: "40px" }}>
      Meil on lõõgastumiseks kõik vajalik olemas:
    </h2>
  ),
};

export default avaleht;
